import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Insights from  '@/components/page/Insights';


class InsightsPortal extends Component {
  render() {

    // Container ref
    const targetContainer = document.getElementById('react-insights-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
        <Insights />, targetContainer
    );
  }
}

export default InsightsPortal;